<div class="row account-filter">
  <div class="col-sm-12 col-md-9 col-lg-9 col-xl-10 padding-l0 padding-r0 smallPadRgt0">
    <div class="row search-box-outer xs-full-width">
      <div class="col-4 col-md-4 col-lg-3 padding-r0 borderRight category-drop-outer">
        <div class="category-dropdown material-select">
          <ng-select 
                     name="ddlSeedReturnSearch"
                     [(ngModel)]="selectedFilter"
                     (ngModelChange)="enableDisableSearchButton()"
                     [virtualScroll]="true"
                     [closeOnSelect]="true"
                     [selectOnTab]="true"
                     [clearable]="false"
                     labelForId="name"
                     [searchable]="false"
                     (change)="retainFilter(null, ' ')"
                     data-testid="ddl-cpp-return-search">
            <ng-option *ngFor="let option of filterList; let i = index;" [value]="option.column">
              <span [attr.data-testid]="'ddl-filter-select_'+option.column">{{option.label}}</span>
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="col-8 col-md-8 col-lg-9 padding-l4 padding-r0">
        <div class="material-select account-search">
          <div *ngIf="selectedFilter === 'productName'">
            <div class="search-box-outer xs-full-width">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input (keyup.enter)="selectProductName($event)"
                         (ngModelChange)="validateProductSearch(productFilters.productName)"
                         (paste)="onPaste($event)"
                         [(ngModel)]="productFilters.productName" placeholder="Search..." type="text" data-testid="ddl-product-name-search">
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedFilter === 'conLotNumber'">
            <div class="search-box-outer xs-full-width">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input (keyup.enter)="selectLotNumber($event)"
                         (ngModelChange)="validateProductSearch(productFilters.conLotNumber)"
                         (paste)="onPaste($event)"
                         [(ngModel)]="productFilters.conLotNumber" placeholder="Search..." type="text" data-testid="ddl-lot-number-search">
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedFilter === 'conItemNumber'">
            <div class="search-box-outer xs-full-width">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input (keyup.enter)="selectContainerItemNumber($event)"
                         (ngModelChange)="validateProductSearch(productFilters.conItemNumber)"
                         (paste)="onPaste($event)"
                         [(ngModel)]="productFilters.conItemNumber" placeholder="Search..." type="text" data-testid="ddl-item-number-search">
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedFilter === 'packageSize'">
            <div class="search-box-outer">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input (keyup.enter)="selectPackageSize($event)"
                         (ngModelChange)="validateProductSearch(productFilters.packageSize)"
                         (paste)="onPaste($event)"
                         [(ngModel)]="productFilters.packageSize" placeholder="Search..." type="text" data-testid="ddl-package-size-search">
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedFilter === 'vendorName'">
            <div class="search-box-outer">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input (keyup.enter)="selectVendortName($event)"
                         (ngModelChange)="validateProductSearch(productFilters.vendorName)"
                         (paste)="onPaste($event)"
                         [(ngModel)]="productFilters.vendorName" placeholder="Search..." type="text" data-testid="ddl-vendor-name-search">
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedFilter=='activeIngredients'">
            <div class="search-box-outer">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input (keyup.enter)="selectActiveIngredient($event)" [(ngModel)]="productFilters.activeIngredient"
                         (paste)="onPaste($event)"
                         (ngModelChange)="validateProductSearch(productFilters.activeIngredient)" placeholder="Search..." type="text" data-testid="ddl-active-ingredients-search">
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedFilter=='gtin'">
            <div class="search-box-outer">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input (keyup.enter)="retainFilter(null, ' ');onFilter();" [(ngModel)]="productFilters.gtin"
                         (paste)="onPaste($event)"
                         (ngModelChange)="validateProductSearch(productFilters.gtin)" placeholder="Search..." type="text" data-testid="ddl-gtin-search">
                </div>
              </div>
            </div>
          </div>
          <ng-select #ProductLine name="ddlproductSearch" *ngIf="selectedFilter === 'productLine'"
                     [items]="productLineMasterList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.productLine"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(productLine,'ProductLine')"
                     data-testid="ddl-productline-search">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-productline-option_'+item.value">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <ng-select #itemNo name="ddlItemNoSearch" *ngIf="selectedFilter === 'itemNumber'"
                     [items]="invoicedProductList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.itemNo"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(itemNo,'ItemNo')"
                     data-testid="ddl-itemnumber-search">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-itemnumber-option_'+item.value">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <ng-select #itemNo name="ddlConPackageSizeSearch" *ngIf="selectedFilter === 'conPackageSize'"
                     [items]="packageSizeList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.conPackageSize"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="id"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(conPackageSize,'ConPackageSize')"
                     data-testid="ddl-packagesize-search">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-packagesize-option_'+item.value">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <!--<div class="search-btn">
            <button mat-raised-button class="btns" color="primary" [disabled]="disableFilterBtn" (click)="onFilter()">Search</button>
          </div>-->
        </div>
      </div>
    </div>
    <div class="row selected-chip xs-pt-5 xs-pb-5 md-pt-10 md-pb-10">
      <div class="col-9 col-md-10 ">
        <div>
          <mat-chip-set>
            <mat-chip selected *ngFor="let filterValue of filterValueList">
              {{filterValue}}
              <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                <i class="fas fa-times text-right"></i>
              </a>
            </mat-chip>
          </mat-chip-set>
        </div>
      </div>
      <div class="col-3 col-md-2 text-right padding-r0" *ngIf="filterValueList.length > 0">
        <a href="Javascript:void(0);" class="clearAll" (click)="removeAllFilter()">Clear All</a>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-3 col-lg-3 col-xl-2 search-btn-outer text-center padding-r0 padding-l0 margin-t-20">
    <div class="search-btn">
      <button mat-raised-button class="btns md-mt-20 xs-mt-0" color="primary" [disabled]="disableFilterBtn" (click)="onFilter()" data-testid="ddl-product-search">Search</button>
    </div>
  </div>
</div>
